function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -996.362)",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.96 1014.362c-1.085 0-1.96.892-1.96 2v14c.216 1.4.818 1.769 1.96 2H50.01a1.988 1.988 0 001.991-2v-14c0-1.108-.875-2-1.96-2h-2.942c-1.086 0-1.96.892-1.96 2v7.28c-.138 1.72-.12 1.72-1.914 1.72H10.685c-1.685 0-1.685-1-1.822-1.864v-7.136c0-1.108-.875-2-1.961-2H3.961z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.04 1006.362h13.92c1.13 0 2.04.892 2.04 2v15c0 1.108-.91 2-2.04 2H11.04c-1.13 0-2.04-.892-2.04-2v-15c0-1.108.91-2 2.04-2z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 2,
  rx: 2.04,
  y: 1006.362,
  x: 27,
  height: 19,
  width: 18
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.04 1020.362h13.92c1.13 0 2.04.235 2.04.527v3.947c0 .292-.91.526-2.04.526H11.04c-1.13 0-2.04-.235-2.04-.526v-3.947c0-.292.91-.527 2.04-.527z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 5,
  x: 27,
  y: 1020.362,
  rx: 2.04,
  ry: 0.526
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 1032.362h5v5H5zM44.2 1032.362h5v5h-5z"
}));

var SvgCouch = function SvgCouch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCouch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Couch.0c22984d.svg";
export { ForwardRef as ReactComponent };